import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollTaxDetail  {
    _originalTypeClassName = "zERP.BO.PayrollTaxDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollTaxDetail.translate = translateService;
}
this.Salaries = [];
this.Items = [];
this.Id = null;
this.TaxableAmount = null;
this.NonRegularTaxableAmount = null;
this.TotalTaxableAmount = null;
this.RegularTax = null;
this.NotRegularTax = null;
this.Tax = null;
this.TaxType = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TaxableAmount:any;
NonRegularTaxableAmount:any;
TotalTaxableAmount:any;
RegularTax:any;
NotRegularTax:any;
Tax:any;
TaxType:any;
Salaries:any;
Items:any;
static setSalaries = ($this, items) => {
                if (items == null) items = [];
                if ($this.Salaries == null) $this.Salaries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Salaries.length > 0) {
                    Domain.PayrollTaxDetail.removeSalaries($this, $this.Salaries[0]);
                }

                Domain.PayrollTaxDetail.addManySalaries($this, copyItems);
            }
static addManySalaries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollTaxDetail.addSalaries($this, items[i]);
                }
            }
static addSalaries = ($this, item) => {
                if ($this.Salaries == null) $this.Salaries = [];
                if (item == null || $this.Salaries.indexOf(item) > -1) return;
                $this.Salaries.push(item);
}
static addRangeSalaries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollTaxDetail.addSalaries($this, item));
            }
static removeSalaries = ($this, item) => {
                if ($this == null || $this.Salaries == null || $this.Salaries.indexOf(item) === -1) return;
                var _index = $this.Salaries.indexOf(item);
                $this.Salaries.splice(_index, 1);
}
static clearSalaries = ($this) => { $this.Salaries = null; }
static setItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.Items == null) $this.Items = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Items.length > 0) {
                    Domain.PayrollTaxDetail.removeItems($this, $this.Items[0]);
                }

                Domain.PayrollTaxDetail.addManyItems($this, copyItems);
            }
static addManyItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollTaxDetail.addItems($this, items[i]);
                }
            }
static addItems = ($this, item) => {
                if ($this.Items == null) $this.Items = [];
                if (item == null || $this.Items.indexOf(item) > -1) return;
                $this.Items.push(item);
}
static addRangeItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollTaxDetail.addItems($this, item));
            }
static removeItems = ($this, item) => {
                if ($this == null || $this.Items == null || $this.Items.indexOf(item) === -1) return;
                var _index = $this.Items.indexOf(item);
                $this.Items.splice(_index, 1);
}
static clearItems = ($this) => { $this.Items = null; }

static GetTotalTaxableAmount($this: any): any{return Joove.Common.safeNumber($this?.TaxableAmount) + Joove.Common.safeNumber($this?.NonRegularTaxableAmount);
}
static RoundAmounts($this: any, entity: any): any{if (CLMS.Framework.Number.GreaterThan(() => $this.Tax, () => 0)) {}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}